import { render, staticRenderFns } from "./property.vue?vue&type=template&id=3a8c7668&"
import script from "./property.vue?vue&type=script&lang=js&"
export * from "./property.vue?vue&type=script&lang=js&"
import style0 from "./property.vue?vue&type=style&index=0&id=3a8c7668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports